import { render, staticRenderFns } from "./book-search.vue?vue&type=template&id=642dc155&scoped=true&"
import script from "./book-search.vue?vue&type=script&lang=js&"
export * from "./book-search.vue?vue&type=script&lang=js&"
import style0 from "./book-search.vue?vue&type=style&index=0&id=642dc155&prod&lang=css&"
import style1 from "./book-search.vue?vue&type=style&index=1&id=642dc155&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642dc155",
  null
  
)

export default component.exports